import { useSyncExternalStore } from "react";
import { subscribeToData, getDataVersion } from "@/lib/data";

/**
 * Subscribes the calling component to CMS-data updates.
 *
 * data.ts exports (products, events, etc.) are module-level `let`
 * re-assignments — React has no way to know they changed and won't
 * re-render on its own. Components that conditionally render based on
 * those exports (e.g. EventsSection returns null when events is empty)
 * must call this hook to re-render when initializeData() resolves.
 *
 * Returns the current version number. Callers typically ignore the
 * value; the subscription itself is what matters.
 */
export function useDataVersion(): number {
  return useSyncExternalStore(
    subscribeToData,
    getDataVersion,
    // Server snapshot — during SSR/prerender, getDataVersion() returns 0.
    // The prerender script awaits initializeData() before rendering, so
    // components see the populated exports directly; the version doesn't
    // need to change on the server.
    getDataVersion,
  );
}
